import { api } from 'api';
import { requestErrorAction } from 'common/utils/requestErrorHandling';
import { PaginatedResponse, PaginationParams } from '../types';
import { Notification, NotificationSatuses } from './actions';

export interface NotificationParams extends PaginationParams {
  status?: NotificationSatuses;
}

export const requestNotifications = async (params?: NotificationParams) =>
  await api.get<PaginatedResponse<Notification>>('/notification/', {
    params,
  });

export const doGetNotifications =
  (params?: NotificationParams) => async (dispatch) => {
    dispatch({ type: 'notifications/started' });
    try {
      const response = await requestNotifications(params);

      dispatch({
        type: 'notifications/finished',
        notifications: response.data.results,
        count: response.data.count,
        next: response.data.next,
        previous: response.data.previous,
      });
    } catch (e) {
      dispatch(
        requestErrorAction(
          { type: 'notifications/finished' },
          e,
          `Failed to get notifications.`
        )
      );
    }
  };

export const requestAcknowledgeNotifications = async (id: number) =>
  await api.patch(`/notification/${id}`, {
    status: NotificationSatuses.ACKNOWLEDGED,
  });

export const doAcknowledgeNotifications = (id: number) => async (dispatch) => {
  dispatch({ type: 'notification/acknowledge/started' });
  try {
    await requestAcknowledgeNotifications(id);

    dispatch({
      type: 'notification/acknowledge/finished',
      success: true,
    });
  } catch (e) {
    dispatch(
      requestErrorAction(
        { type: 'notification/acknowledge/finished', success: false },
        e,
        `Failed to acknowledge notification.`
      )
    );
  }
};
